import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Check, Sparkles } from "lucide-react";
import { Reveal, LineReveal } from "../lib/motion";
import { CHAPTERS } from "../data";

export const Promo = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x1 = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section id="promo" ref={ref} className="relative bg-gold text-navy-deep overflow-hidden py-24 md:py-32">
      {/* moving oversized watermark */}
      <motion.span
        style={{ x: x1 }}
        className="pointer-events-none absolute -top-4 left-0 whitespace-nowrap font-display uppercase text-[26vw] leading-none text-navy-deep/[0.06] select-none"
      >
        Test Run · Test Run ·
      </motion.span>

      <div className="relative z-10 mx-auto max-w-[1200px] px-6 md:px-10">
        <Reveal>
          <div className="inline-flex items-center gap-2 border border-navy-deep/40 rounded-full px-5 py-2 mb-8">
            <Sparkles size={15} />
            <span className="text-xs uppercase tracking-luxe font-semibold">Limited-Time Promotional Test Run</span>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-center">
          <div>
            <h2 className="font-display uppercase leading-[0.85] tracking-tight">
              <span className="block text-[16vw] sm:text-[13vw] lg:text-[11rem]">
                <LineReveal lines={["$50"]} />
              </span>
              <span className="block text-3xl md:text-5xl mt-1">
                <LineReveal lines={["for 5 posts"]} delay={0.15} />
              </span>
            </h2>

            <Reveal delay={0.2}>
              <p className="mt-8 text-navy-deep/80 text-lg md:text-xl font-light max-w-lg leading-relaxed">
                We're launching promotional test-run posts to grow our brand — and
                you get the win. If you're a customer in <strong className="font-semibold">any of our four</strong> service
                areas, we'll create <strong className="font-semibold">5 posts for just $50.</strong>
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="bg-navy-deep text-cream rounded-2xl p-8 md:p-10 border border-navy-deep">
              <p className="text-gold text-xs uppercase tracking-luxe mb-6">Qualify if you're a…</p>
              <ul className="space-y-4">
                {CHAPTERS.map((c) => (
                  <li key={c.id} className="flex items-start gap-3">
                    <span className="mt-0.5 shrink-0 h-6 w-6 rounded-full bg-gold text-navy-deep flex items-center justify-center">
                      <Check size={14} strokeWidth={3} />
                    </span>
                    <span className="font-light">{c.title}</span>
                  </li>
                ))}
              </ul>
              <button
                data-testid="promo-cta"
                onClick={() => document.querySelector("#contact").scrollIntoView({ behavior: "smooth" })}
                className="mt-9 w-full bg-gold text-navy-deep font-semibold uppercase tracking-[0.15em] text-xs px-8 py-4 rounded-full hover:bg-gold-light transition-colors duration-300"
              >
                Claim My 5 Posts
              </button>
              <p className="mt-4 text-center text-cream/50 text-xs">Spots are limited during our test run.</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
